import React from "react";
import PropTypes from "prop-types";

import SubmissionsGridItemContent from "./SubmissionsGridItemContent";

import { AssetContainer } from "core/UploadsGrid/styles";

const SubmissionsDeniedItem = ({ data }) => (
    <AssetContainer>
        <SubmissionsGridItemContent data={data} />
    </AssetContainer>
);

SubmissionsDeniedItem.propTypes = {
    data: PropTypes.shape({
        thumbnail: PropTypes.string,
        originalFilename: PropTypes.string
    })
};

export default SubmissionsDeniedItem;
